export default __webpack_public_path__ + "static/media/Christian Sena.f8cde57a.jpg";